<template>
  <div class="">
    <p class="text-center expansion-header">5-Generation Pedigree</p>
    <div>
      <!-- Father -->
      <div class="pdd">
        <div class="pdd">
          <!-- F4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.sires &&
                  siress.sires.sires &&
                  siress.sires.sires.sires &&
                  siress.sires.sires.sires.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img>
              <span
                @click="redirectToAnimal(siress.sires.sires.sires.animalNumber)"
                >{{
                  (siress &&
                    siress.sires &&
                    siress.sires.sires &&
                    siress.sires.sires.sires &&
                    siress.sires.sires.sires.animalNumber) ||
                  "NA"
                }}</span
              >[{{
                (siress &&
                  siress.sires &&
                  siress.sires.sires &&
                  siress.sires.sires.sires &&
                  siress.sires.sires.sires.name) ||
                "NA"
              }}]
            </div>
          </div>
          <!-- F3 -->
          <div class="center">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.sires &&
                  siress.sires.sires &&
                  siress.sires.sires.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img>
              <span @click="redirectToAnimal(siress.sires.sires.animalNumber)">
                {{
                  (siress &&
                    siress.sires &&
                    siress.sires.sires &&
                    siress.sires.sires.animalNumber) ||
                  "N/A"
                }} </span
              >[{{
                (siress &&
                  siress.sires &&
                  siress.sires.sires &&
                  siress.sires.sires.name) ||
                "N/A"
              }}]
            </div>
          </div>
          <!-- M4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.sires &&
                  siress.sires.sires &&
                  siress.sires.sires.dams &&
                  siress.sires.sires.dams.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span
                @click="redirectToAnimal(siress.sires.sires.dams.animalNumber)"
                >{{
                  (siress &&
                    siress.sires &&
                    siress.sires.sires &&
                    siress.sires.sires.dams &&
                    siress.sires.sires.dams.animalNumber) ||
                  "NA"
                }}</span
              >[{{
                (siress &&
                  siress.sires &&
                  siress.sires.sires &&
                  siress.sires.sires.dams &&
                  siress.sires.sires.dams.name) ||
                "NA"
              }}]
            </div>
          </div>
        </div>
        <div class="pdd">
          <div class="left">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.sires &&
                  siress.sires.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img>
              <span @click="redirectToAnimal(siress.sires.animalNumber)">{{
                (siress && siress.sires && siress.sires.animalNumber) || "N/A"
              }}</span
              >[{{ (siress && siress.sires && siress.sires.name) || "N/A" }}]
            </div>
          </div>
        </div>
        <div class="pdd">
          <!-- F4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.sires &&
                  siress.sires.dams &&
                  siress.sires.dams.sires &&
                  siress.sires.dams.sires.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img
              ><span
                @click="redirectToAnimal(siress.sires.dams.sires.animalNumber)"
                >{{
                  (siress &&
                    siress.sires &&
                    siress.sires.dams &&
                    siress.sires.dams.sires &&
                    siress.sires.dams.sires.animalNumber) ||
                  "NA"
                }}</span
              >[{{
                (siress &&
                  siress.sires &&
                  siress.sires.dams &&
                  siress.sires.dams.sires &&
                  siress.sires.dams.sires.animalNumber) ||
                "NA"
              }}]
            </div>
          </div>

          <!-- M3 -->
          <div class="center">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.sires &&
                  siress.sires.dams &&
                  siress.sires.dams.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span @click="redirectToAnimal(siress.sires.dams.animalNumber)"
                >{{
                  (siress &&
                    siress.sires &&
                    siress.sires.dams &&
                    siress.sires.dams.animalNumber) ||
                  "N/A"
                }}
              </span>
              [{{
                (siress &&
                  siress.sires &&
                  siress.sires.dams &&
                  siress.sires.dams.name) ||
                "N/A"
              }}]
            </div>
          </div>

          <!-- M4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.sires &&
                  siress.sires.dams &&
                  siress.sires.dams.dams &&
                  siress.sires.dams.dams.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span
                @click="redirectToAnimal(siress.sires.dams.dams.animalNumber)"
                >{{
                  (siress &&
                    siress.sires &&
                    siress.sires.dams &&
                    siress.sires.dams.dams &&
                    siress.sires.dams.dams.animalNumber) ||
                  "NA"
                }}</span
              >
              [{{
                (siress &&
                  siress.sires &&
                  siress.sires.dams &&
                  siress.sires.dams.dams &&
                  siress.sires.dams.dams.name) ||
                "NA"
              }}]
            </div>
          </div>
        </div>
      </div>
      <!-- Current Animal -->
      <div class="title-page">
        <span class="font-weight-bold mr-1 black--text">Sire: </span
        ><span
          @click="redirectToAnimal(siress.animalNumber)"
          :class="{ invisible: !(siress && siress.animalNumber) }"
        >
          {{ (siress && siress.animalNumber) || "N/A" }}</span
        >
        [{{ (siress && siress.name) || "N/A" }}]
      </div>
      <!-- Mother -->
      <div class="pdd">
        <!-- F3 -->
        <div class="pdd">
          <!-- F4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.dams &&
                  siress.dams.sires &&
                  siress.dams.sires.sires &&
                  siress.dams.sires.sires.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img
              ><span
                @click="redirectToAnimal(siress.dams.sires.sires.animalNumber)"
                >{{
                  (siress &&
                    siress.dams &&
                    siress.dams.sires &&
                    siress.dams.sires.sires &&
                    siress.dams.sires.sires.animalNumber) ||
                  "NA"
                }}</span
              >
              [{{
                (siress &&
                  siress.dams &&
                  siress.dams.sires &&
                  siress.dams.sires.sires &&
                  siress.dams.sires.sires.name) ||
                "NA"
              }}]
            </div>
          </div>

          <!-- F3 -->
          <div class="center">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.dams &&
                  siress.dams.sires &&
                  siress.dams.sires.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img
              ><span
                @click="redirectToAnimal(siress.dams.sires.animalNumber)"
                >{{
                  (siress &&
                    siress.dams &&
                    siress.dams.sires &&
                    siress.dams.sires.animalNumber) ||
                  "NA"
                }}</span
              >
              [{{
                (siress &&
                  siress.dams &&
                  siress.dams.sires &&
                  siress.dams.sires.name) ||
                "NA"
              }}]
            </div>
          </div>

          <!-- M4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.dams &&
                  siress.dams.sires &&
                  siress.dams.sires.dams &&
                  siress.dams.sires.dams.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span
                @click="redirectToAnimal(siress.dams.sires.dams.animalNumber)"
                >{{
                  (siress &&
                    siress.dams &&
                    siress.dams.sires &&
                    siress.dams.sires.dams &&
                    siress.dams.sires.dams.animalNumber) ||
                  "NA"
                }}</span
              >
              [{{
                (siress &&
                  siress.dams &&
                  siress.dams.sires &&
                  siress.dams.sires.dams &&
                  siress.dams.sires.dams.name) ||
                "NA"
              }}]
            </div>
          </div>
        </div>

        <!-- M2 -->
        <div class="left">
          <div
            class="set-img"
            :class="{
              invisible: !(siress && siress.dams && siress.dams.animalNumber),
            }"
          >
            <v-img src="/img/rowup.png"></v-img
            ><span @click="redirectToAnimal(siress.dams.animalNumber)">{{
              (siress && siress.dams && siress.dams.animalNumber) || "NA"
            }}</span
            >[{{ (siress && siress.dams && siress.dams.name) || "NA" }}]
          </div>
        </div>

        <!-- M3 -->
        <div class="pdd">
          <!-- F4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.dams &&
                  siress.dams.dams &&
                  siress.dams.dams.sires &&
                  siress.dams.dams.sires.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img
              ><span
                @click="redirectToAnimal(siress.dams.dams.sires.animalNumber)"
                >{{
                  (siress &&
                    siress.dams &&
                    siress.dams.dams &&
                    siress.dams.dams.sires &&
                    siress.dams.dams.sires.animalNumber) ||
                  "NA"
                }}</span
              >[{{
                (siress &&
                  siress.dams &&
                  siress.dams.dams &&
                  siress.dams.dams.sires &&
                  siress.dams.dams.sires.name) ||
                "NA"
              }}]
            </div>
          </div>
          <!-- M3 -->
          <div class="center">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.dams &&
                  siress.dams.dams &&
                  siress.dams.dams.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span @click="redirectToAnimal(siress.dams.dams.animalNumber)">{{
                siress &&
                siress.dams &&
                siress.dams.dams &&
                siress.dams.dams.animalNumber
              }}</span
              >[{{
                siress &&
                siress.dams &&
                siress.dams.dams &&
                siress.dams.dams.name
              }}]
            </div>
          </div>

          <!-- M4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  siress &&
                  siress.dams &&
                  siress.dams.dams &&
                  siress.dams.dams.dams &&
                  siress.dams.dams.dams.animalNumber
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span
                @click="redirectToAnimal(siress.dams.dams.dams.animalNumber)"
                >{{
                  (siress &&
                    siress.dams &&
                    siress.dams.dams &&
                    siress.dams.dams.dams &&
                    siress.dams.dams.dams.animalNumber) ||
                  "NA"
                }}</span
              >[{{
                (siress &&
                  siress.dams &&
                  siress.dams.dams &&
                  siress.dams.dams.dams &&
                  siress.dams.dams.dams.name) ||
                "NA"
              }}]
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-divider class="my-10"></v-divider>

    <div>
      <!-- Father -->
      <div class="pdd">
        <div class="pdd">
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  damss &&
                  damss.sires &&
                  damss.sires.sires &&
                  damss.sires.sires.sirePubId
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img>
              <span @click="redirectToAnimal(damss.sires.sires.sirePubId)">{{
                (damss &&
                  damss.sires &&
                  damss.sires.sires &&
                  damss.sires.sires.sirePubId) ||
                "NA"
              }}</span>
              [{{
                (damss &&
                  damss.sires &&
                  damss.sires.sires &&
                  damss.sires.sires.sires &&
                  damss.sires.sires.sires.name) ||
                "NA"
              }}]
            </div>
          </div>
          <div class="center">
            <div
              class="set-img"
              :class="{
                invisible: !(damss && damss.sires && damss.sires.sirePubId),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img>
              <span @click="redirectToAnimal(damss.sires.sirePubId)"
                >{{ (damss && damss.sires && damss.sires.sirePubId) || "NA" }}
              </span>
              [{{
                (damss &&
                  damss.sires &&
                  damss.sires.sires &&
                  damss.sires.sires.name) ||
                "NA"
              }}]
            </div>
          </div>
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  damss &&
                  damss.sires &&
                  damss.sires.sires &&
                  damss.sires.sires.damPubId
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span @click="redirectToAnimal(damss.sires.sires.damPubId)">{{
                (damss &&
                  damss.sires &&
                  damss.sires.sires &&
                  damss.sires.sires.damPubId) ||
                "NA"
              }}</span>
              [{{
                (damss &&
                  damss.sires &&
                  damss.sires.sires &&
                  damss.sires.sires.dams &&
                  damss.sires.sires.dams.name) ||
                "NA"
              }}]
            </div>
          </div>
        </div>
        <div class="pdd">
          <div class="left">
            <div
              class="set-img"
              :class="{ invisible: !(damss && damss.sirePubId) }"
            >
              <v-img src="/img/rowdown.png"></v-img>
              <span @click="redirectToAnimal(damss.sirePubId)">{{
                (damss && damss.sirePubId) || "N/A"
              }}</span>
              [{{ (damss && damss.sires && damss.sires.name) || "N/A" }}]
            </div>
          </div>
        </div>
        <div class="pdd">
          <!-- F4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  damss &&
                  damss.sires &&
                  damss.sires.dams &&
                  damss.sires.dams.sirePubId
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img
              ><span @click="redirectToAnimal(damss.sirePubId)">{{
                (damss &&
                  damss.sires &&
                  damss.sires.dams &&
                  damss.sires.dams.sirePubId) ||
                "NA"
              }}</span>
            </div>
          </div>
          <!-- M3 -->
          <div class="center">
            <div
              class="set-img"
              :class="{
                invisible: !(damss && damss.sires && damss.sires.damPubId),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span @click="redirectToAnimal(damss.sirePubId)"
                >{{
                  (damss && damss.sires && damss.sires.damPubId) || "NA"
                }} </span
              >[{{
                (damss &&
                  damss.sires &&
                  damss.sires.dams &&
                  damss.sires.dams.name) ||
                "NA"
              }}]
            </div>
          </div>
          <!-- M4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  damss &&
                  damss.sires &&
                  damss.sires.dams &&
                  damss.sires.dams.damPubId
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span @click="redirectToAnimal(damss.sires.dams.damPubId)">{{
                (damss &&
                  damss.sires &&
                  damss.sires.dams &&
                  damss.sires.dams.damPubId) ||
                "NA"
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Current Animal -->
      <!-- M1 -->
      <div class="title-page">
        <span class="font-weight-bold mr-1 black--text">Dam: </span
        ><span
          @click="redirectToAnimal(damss.animalNumber)"
          :class="{ invisible: !(damss && damss.animalNumber) }"
          >{{ (damss && damss.animalNumber) || "N/A" }} </span
        >[{{ (damss && damss.name) || "N/A" }}]
      </div>
      <!-- Mother -->
      <div class="pdd">
        <div class="pdd">
          <!-- F4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  damss &&
                  damss.dams &&
                  damss.dams.sires &&
                  damss.dams.sires.sirePubId
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img
              ><span @click="redirectToAnimal(damss.dams.sires.sirePubId)">{{
                (damss &&
                  damss.dams &&
                  damss.dams.sires &&
                  damss.dams.sires.sirePubId) ||
                "NA"
              }}</span>
              [{{
                (damss &&
                  damss.dams &&
                  damss.dams.sires &&
                  damss.dams.sires.sires &&
                  damss.dams.sires.sires.name) ||
                "NA"
              }}]
            </div>
          </div>

          <!-- F3 -->
          <div class="center">
            <div
              class="set-img"
              :class="{
                invisible: !(damss && damss.dams && damss.dams.sirePubId),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img
              ><span @click="redirectToAnimal(damss.dams.sirePubId)">{{
                (damss && damss.dams && damss.dams.sirePubId) || "N/A"
              }}</span
              >[{{
                (damss &&
                  damss.dams &&
                  damss.dams.sires &&
                  damss.dams.sires.name) ||
                "N/A"
              }}]
            </div>
          </div>

          <!-- M4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  damss &&
                  damss.dams &&
                  damss.dams.sires &&
                  damss.dams.sires.damPubId
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span @click="redirectToAnimal(damss.dams.sires.damPubId)">{{
                (damss &&
                  damss.dams &&
                  damss.dams.sires &&
                  damss.dams.sires.damPubId) ||
                "NA"
              }}</span>
              [{{
                (damss &&
                  damss.dams &&
                  damss.dams.sires &&
                  damss.dams.sires.dams &&
                  damss.dams.sires.dams.name) ||
                "NA"
              }}]
            </div>
          </div>
        </div>

        <!-- M2 -->
        <div class="left">
          <div
            class="set-img"
            :class="{ invisible: !(damss && damss.damPubId) }"
          >
            <v-img src="/img/rowup.png"></v-img
            ><span @click="redirectToAnimal(damss.damPubId)">{{
              (damss && damss.damPubId) || "N/A"
            }}</span
            >[{{ (damss && damss.dams && damss.dams.name) || "N/A" }}]
          </div>
        </div>

        <div class="pdd">
          <!-- F4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  damss &&
                  damss.dams &&
                  damss.dams.dams &&
                  damss.dams.dams.sirePubId
                ),
              }"
            >
              <v-img src="/img/rowdown.png"></v-img
              ><span @click="redirectToAnimal(damss.dams.dams.sirePubId)">{{
                (damss &&
                  damss.dams &&
                  damss.dams.dams &&
                  damss.dams.dams.sirePubId) ||
                "NA"
              }}</span
              >[{{
                (damss &&
                  damss.dams &&
                  damss.dams.dams &&
                  damss.dams.dams.sires &&
                  damss.dams.dams.sires.name) ||
                "NA"
              }}]
            </div>
          </div>

          <!-- M3 -->
          <div class="center">
            <div
              class="set-img"
              :class="{
                invisible: !(damss && damss.dams && damss.dams.damPubId),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span @click="redirectToAnimal(damss.dams.damPubId)">{{
                (damss && damss.dams && damss.dams.damPubId) || "N/A"
              }}</span
              >[{{
                (damss &&
                  damss.dams &&
                  damss.dams.dams &&
                  damss.dams.dams.name) ||
                "N/A"
              }}]
            </div>
          </div>

          <!-- M4 -->
          <div class="right">
            <div
              class="set-img"
              :class="{
                invisible: !(
                  damss &&
                  damss.dams &&
                  damss.dams.dams &&
                  damss.dams.dams.damPubId
                ),
              }"
            >
              <v-img src="/img/rowup.png"></v-img
              ><span @click="redirectToAnimal(damss.dams.dams.damPubId)"
                >M4-
                {{
                  (damss &&
                    damss.dams &&
                    damss.dams.dams &&
                    damss.dams.dams.damPubId) ||
                  "NA"
                }}</span
              >
              [{{
                (damss &&
                  damss.dams &&
                  damss.dams.dams &&
                  damss.dams.dams.dams &&
                  damss.dams.dams.dams.name) ||
                "NA"
              }}]
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  props: {
    epdId: Number,
  },
  async mounted() {
    this.startLoading();
    const pedigree = await AnimalService.getAnimalPedigree(this.epdId);

    if (pedigree?.data) {
      const pedigreeData = pedigree?.data?.getPedigree;
      this.siress = pedigreeData?.sires;
      this.damss = pedigreeData?.dams;

      // this.stopLoading();
      this.loading = false;
    } else if (pedigree?.errors) {
      this.loading = false;

      console.log(pedigree?.errors);
    }
    this.stopLoading();
  },
  data() {
    return {
      siress: null,
      damss: null,
      siresss: {
        animalNumber: "ANI000020832191",
        name: "AC Animal",
        sirePubId: "19acad29-dfc6-482b-8d43-f63bba70751d",
        damPubId: "ANI000017962717",
        sires: {
          id: 9,
          animalNumber: "19acad29-dfc6-482b-8d43-f63bba70751d",
          name: "DGSDF",
          sirePubId: "5c1bc027-2f37-4967-8981-08bd6aeebd31",
          damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
          sires: {
            id: 8,
            animalNumber: "5c1bc027-2f37-4967-8981-08bd6aeebd31",
            name: "hhhgfh",
            sirePubId: "",
            damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
            sires: {
              id: null,
              animalNumber: null,
              name: null,
              sirePubId: null,
              damPubId: null,
            },
            dams: {
              id: 1,
              animalNumber: "783f74ec-8326-41dc-b175-3827e5d609b7",
              name: "lukki",
              sirePubId: "ANI000020832191",
              damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
            },
          },
        },
        dams: {
          id: 17,
          animalNumber: "ANI000017962717",
          name: "JDHAB",
          sirePubId: "19acad29-dfc6-482b-8d43-f63bba70751d",
          damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
          sires: {
            id: 9,
            animalNumber: "19acad29-dfc6-482b-8d43-f63bba70751d",
            name: "DGSDF",
            sirePubId: "5c1bc027-2f37-4967-8981-08bd6aeebd31",
            damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
            sires: {
              id: 8,
              animalNumber: "5c1bc027-2f37-4967-8981-08bd6aeebd31",
              name: "hhhgfh",
              sirePubId: "",
              damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
            },
            dams: {
              id: 1,
              animalNumber: "783f74ec-8326-41dc-b175-3827e5d609b7",
              name: "lukki",
              sirePubId: "ANI000020832191",
              damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
            },
          },
        },
      },
    };
  },
  methods: {
    redirectToAnimal(animalNumber) {
      if (animalNumber) {
        const routeData = this.$router.resolve({
          name: "SingleAnimalEpd",
          params: { geneticid: animalNumber },
        });
        window.open(routeData.href, "_blank");
      }
    },
  },
  mixins: [loadingMixin],
};
</script>
<style scoped>
.expansion-header {
  border: 1px solid #ffb443 !important;
  background-color: #fff7ec !important;
  min-height: 50px;
  border-radius: 5px;
  vertical-align: middle;
  padding: 10px;
  color: #787878;
  font-weight: 400;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.set-img {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0px;
  justify-content: center;
  color: #666666;
  font-size: 14px;
}
.set-img .v-image.v-responsive.theme--light {
  max-width: 85px !important;
}
.right .set-img {
  justify-content: left;
  margin: 0px 0px 0px 42%;
  white-space: nowrap;
}
.left .set-img {
  margin: 0px 0px 0px 123px;
  justify-content: left;
}
.center .set-img {
  margin: 0px 0px 0px 30%;
  white-space: nowrap;
  justify-content: left;
}
.set-img .v-image__image--cover {
  background-size: contain;
}
.set-img span {
  color: #00bd73;
  cursor: pointer;
}

.title-page span {
  color: #00bd73;
  cursor: pointer;
}
.invisible {
  visibility: hidden;
}
</style>
